import { adminApi } from "@/lib/axios";
import { toast } from "react-hot-toast";

export type ReleaseNoteAudience = "AGENCY" | "AFFILIATE" | "BRAND";

export interface CreateReleaseNotePayload {
  title: string;
  description: string; // HTML or rich text content
  targetAudience: ReleaseNoteAudience[];
}

export interface ReleaseNote
  extends Omit<CreateReleaseNotePayload, "targetAudience"> {
  targetAudience: ReleaseNoteAudience[];
  id: string;
  createdAt: string;
  updatedAt: string;
}

export const releaseNotesService = {
  async list(): Promise<ReleaseNote[]> {
    const { data } = await adminApi.get<{
      data: ReleaseNote[];
      message: string;
      success: boolean;
    }>("/release-notes");
    if (data.success) {
      toast.success(data.message);
      return data.data;
    }
    throw new Error(data.message || "Failed to fetch release notes");
  },

  async create(payload: CreateReleaseNotePayload): Promise<ReleaseNote> {
    const { data } = await adminApi.post<ReleaseNote>(
      "/release-notes",
      payload
    );
    console.log(data);
    return data;
  },
};
